import React from "react";

import { Box, Container } from "@mui/material";
import CustomImage from "../../customComponents/customImage.jsx";
import { motion, useInView } from "framer-motion";

import { translation } from "../../assets/translation.js";
import { itemVariants, language } from "../../assets/function.js";
import CustomText from "../../customComponents/customText.jsx";
import { Colors } from "../../assets/colors.js";
import PropTypes from "prop-types";
import CustomTailored from "../../assets/images/customtailored.svg";
import AiMarketPlace from "../../assets/images/aimarketplace.svg";
import SolveWhat from "../../assets/images/solvewhat.svg";
import AiPlugins from "../../assets/images/AiPlugins.svg";
let staticText = translation[language];

const AiViewBox = ({
  textValue,
  imageValue,
  flexDirection = "row",
  columnDirection = "column",
  descValue,
  marginTop = { xs: 0, sm: 14, md: 16 },
  startPos,
  endPos,
  marginBottom = 0,
  columnMarginTop=0,
  ref,
  isInView,
  marginLeft 
}) => (
  <Container
    maxWidth="xl"
    sx={{
      ...styles.containerStyle,
      flexDirection: { xs:columnDirection, md: flexDirection },
      marginTop: marginTop,
      marginBottom: {xs:0,md:marginBottom,xl:marginBottom},

    }}
  >
    <Box
      sx={{
        flexGrow: 1,
        width: { xs: "100%", md: "100%" },
        mb: { xs: 4, md: 0 },
        textAlign: { xs: "center", md: "left" },
        marginTop: {xs:columnMarginTop,md:0},
      }}
    >
      <motion.div
        initial={startPos} // Starting position (hidden and shifted to the left)
        animate={isInView ? { opacity: 1, x: 0, y: 0 } : { opacity: 1, x: 0 }} // Ending position (visible and at normal position)
        transition={{ duration: 1 }} // Duration of the animation
      >
        <CustomText
          desc={textValue}
          fontFamily="Epilogue"
          colorvalue={Colors.andaihubTxt}
          style={{
            ...styles.andaihubTxt,
          }}
          title3
          fontWeight={400}
        />
        <CustomText
          desc={descValue}
          fontFamily="Inter"
          colorvalue={Colors.getAiReadyTxt}
          style={{ ...styles.getAiReadyTxt }}
          h4
          fontWeight={400}
        />
      </motion.div>
    </Box>

    <Box
      sx={{
        flexGrow: 0,
        display: "flex",
        width: { xs: "100%", md: "50%" },
        marginLeft: {xs:0,md:marginLeft},
        ...styles.subcontent1,
      }}
    >
      <motion.div
        ref={ref}
        variants={itemVariants}
        initial={endPos} // Start from the right side
        animate={{ opacity: 1, x: 0 }} // End at the normal position (visible)
        transition={{ duration: 1 }} // Duration of the animation
      >
        <CustomImage filename={imageValue} width={"100%"} height={"auto"} />
      </motion.div>
    </Box>
  </Container>
);

function Aiviewdetails() {
  const ref = React.useRef(null);
  const isInView = useInView(ref, { once: true, amount: 0.3 });
  return (
    <Box sx={styles.appBarStyle}>
      <AiViewBox
        ref={ref}
        isInView={isInView}
        startPos={{ opacity: 0, x: -100 }}
        endPos={{ opacity: 0, x: 30 }}
        marginTop={0}
        textValue={staticText.aiPlugins}
        imageValue={AiPlugins}
        descValue={
          "We have AI Plugins which can be easily integrated into your existing system. We have analyzed every AI solution possible for use case to develop extremely cost effective plugins."
        }
        marginLeft={10}
      />
      <AiViewBox
        ref={ref}
        isInView={isInView}
        textAlign="right"
        endPos={{ opacity: 0, x: -100 }}
        startPos={{ opacity: 0, x: 30 }}
        textValue={staticText.customTailored}
        imageValue={CustomTailored}
        descValue={
          "Your ideas, your Product, and your customers are unique, thus you should never adjust to any common framework. We customize plugins which are cost-effective that also solve your unique problem. "
        }
        flexDirection="row-reverse"
        columnDirection="column-reverse"
        columnMarginTop={5}
        marginLeft={0}
      />
      <AiViewBox

        ref={ref}
        isInView={isInView}
        startPos={{ opacity: 0, x: -100 }}
        endPos={{ opacity: 0, x: 30 }}
        textValue={staticText.solveWhat}
        imageValue={SolveWhat}
        descValue={
          "Most AI solutions do not focus on value addition but that is what differentiates us. We have a state of art model to understand your product and system. We accordingly develop and recommend solutions that matters to you."
        }
        marginLeft={10}
      />
      <AiViewBox
        ref={ref}
        isInView={isInView}
        textAlign="right"
        endPos={{ opacity: 0, x: -100 }}
        startPos={{ opacity: 0, x: 30 }}
        textValue={staticText.aiMarket}
        imageValue={AiMarketPlace}
        descValue={
          "If you are out for shopping for new AI features and don't know where to start, we have got you covered. We have got a marketplace of best AI plugins and niche minds reviewing them."
        }
        flexDirection="row-reverse"
        columnDirection="column-reverse"
        columnMarginTop={5}
        marginBottom={{ xs: 4, sm: 8, md: 16 }}
        marginLeft={0}
      />
    </Box>
  );
}

export default Aiviewdetails;
AiViewBox.propTypes = {
  textValue: PropTypes.string, // Adjust type as needed (e.g., string, number, etc.)
  imageValue: PropTypes.node, // Adjust if it's an element, URL, or React component
  flexDirection: PropTypes.oneOf(["row", "column"]), // Example of limited values
  columnDirection:PropTypes.oneOf(["column","row"]),
  columnMarginTop:PropTypes.number,
  descValue: PropTypes.string, // Adjust type as needed
  marginTop: PropTypes.number,
  startPos: PropTypes.number,
  endPos: PropTypes.number,
  textAlign: PropTypes.oneOf(["left", "center", "right"]),
  marginBottom: PropTypes.number,
  isInView: PropTypes.bool,
  marginLeft: PropTypes.number,
  ref: PropTypes.object,
};
const styles = {
  getAiReadyTxt: {
    marginBottom: { xs: "4vw", md: "2vw" },
    lineHeight: 1.5,
    fontStyle: "initial",
    fontSize: { xs: "16px", sm: "17px", md: "inherit" },
    textAlign: { xs: "left", md: "left" },
  },
  andaihubTxt: {
    marginBottom: { xs: "2vw", md: "0.6vw" },
    lineHeight: 1.1,
    letterSpacing: "-0.01em",
    fontStyle: "initial",
    fontSize: { xs: "20px", sm: "24px", md: "inherit" },
    textAlign: { xs: "left", md: "left" },
  },
  subcontent1: {
    marginRight: { xs: 0, md: 8 },
    width: { xs: "100%", md: "100%" },
    
    
  },
  appBarStyle: {
    overflowX: "hidden",
    boxSizing: "border-box",
    paddingLeft: { xs: "4vw", sm: "8vw", md: "13vw" },
    paddingRight: { xs: "4vw", sm: "8vw", md: "13vw" },
    paddingBottom:{xs:0,md:9,xl:9},
    paddingTop:{xs:0,md:0,xl:16},

  },
  containerStyle: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    paddingLeft: { xs: "4vw", sm: "8vw", md: "2vw", lg : "0vw" },
    paddingRight: { xs: "4vw", sm: "8vw", md: "2vw", lg : "0vw" },
    paddingTop:{xs:5,md:0},
  

  
  },
};
